import { IModule } from 'models/permission';

import * as actions from '../actions/auth';
import { ICompany, ISession } from 'models/session';
import { ISite } from 'models/site';

const initialState: State = {
  session: null,
  permissions: [],
  switchViewSideEffectsHandler: null,
};

export const reducer = (state: State = initialState, action: actions.AuthTypes): State => {
  switch (action.type) {
    case actions.AuthActions.Logout:
      return { ...state, session: null };
    case actions.AuthActions.SetSession:
      return { ...state, session: action.payload.session };
    case actions.AuthActions.AddSessionSite: {
      const companyId = state.session?.view.company;
      const company = state.session?.companies.find((company) => company.id === companyId);

      company?.sites.push(action.payload.site);

      return { ...state };
    }
    case actions.AuthActions.UpdateSessionSite: {
      const updateSession = state.session ? { ...state.session } : null;

      const companyId = updateSession?.view?.company;
      const company = updateSession?.companies?.find((company: ICompany) => company.id === companyId);
      const site = company?.sites.find((site: ISite) => site.id === action.payload.id);

      if (site && action.payload.site.name) {
        site.name = action.payload.site.name;
      }

      return { ...state, session: updateSession };
    }
    case actions.AuthActions.SetAccessToken: {
      return {
        ...state,
        session: { ...state.session!, accessToken: action.payload.accessToken, accessExpiration: action.payload.accessExpiration },
      };
    }
    case actions.AuthActions.SetPermissions:
      return { ...state, permissions: action.payload.permissions };
    case actions.AuthActions.SetView:
      return {
        ...state,
        session: {
          ...state.session!,
          view: {
            operation: action.payload.operationType,
            isSchoolOperationsEnabled: action.payload.isSchoolOperationsEnabled,
            isEmployeeOperationsEnabled: action.payload.isEmployeeOperationsEnabled,
            company: action.payload.company,
            site: action.payload.site,
            relatedEntity: action.payload.relatedEntity,
          },
        },
      };

    case actions.AuthActions.SetSwitchViewSideEffectsHandler:
      return { ...state, switchViewSideEffectsHandler: action.payload };
    default:
      return state;
  }
};

export type State = {
  session: ISession | null;
  permissions: IModule[];
  switchViewSideEffectsHandler: (() => void) | null;
};
